import { useNavigate } from '@tanstack/react-router';
import type { DetailMetadata } from '../../detail-form/types';
import type { SaveEntityResponse } from '../../grid';
import { hasCommand } from '../../grid/commands/utils';

export const useMySelfReviewForm = (
  metadata: DetailMetadata,
  initialValues: Record<string, unknown>,
  basePath: string,
  parentGridKey?: string
) => {
  const navigate = useNavigate();
  const isNewMySelfReview =
    hasCommand(metadata.commands, 'employeereviewsubmit') && !(Number(initialValues.Id) > 0);

  const handleSaveSuccess = (saveResult: SaveEntityResponse) => {
    if (!isNewMySelfReview) return false;

    const savedEntity = saveResult.data.Data?.[0] as { Id?: unknown } | undefined;
    const savedReviewId = String(savedEntity?.Id ?? '').trim();
    if (!savedReviewId) {
      throw new Error('Saved review ID was not returned.');
    }

    navigate({
      to: `${basePath}/${savedReviewId}`,
      search: parentGridKey ? ({ gridContentKey: parentGridKey } as any) : undefined,
      replace: true,
    });
    return true;
  };

  return { initialValues, handleSaveSuccess };
};
